import React from 'react'
import PropTypes from 'prop-types'
import { Box, Link, Typography, styled } from '@mui/material'

const StyledFilterChip = styled(Box)(({ theme, style, colorCodes }) => ({
    ...style,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: style.fontSize ? style.fontSize : '1.2rem',
    padding: style.padding ? style.padding : '0.5rem 1rem',
    border: style.border ? style.border : '0.1rem solid transparent',
}))

const StyledIcon = styled(Box)(({ theme }) => ({
    marginLeft: '1rem',
    cursor: 'pointer',
}))

const FilterChip = ({
    label,
    onClick,
    onClose,
    style,
    colorCodes,
    icon,
    showTooltip = true,
    ...rest
}) => {
    return (
        <Link
            component="span"
            underline="none"
            onClick={onClick}
            title={showTooltip ? label : null}
            {...(onClick && {
                role: 'button',
                tabIndex: 0,
                onKeyDown: (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        onClick()
                    }
                },
            })}
            aria-label={label}
            aria-hidden={!showTooltip}
            aria-describedby={showTooltip ? label : null}
        >
            <StyledFilterChip style={style} colorCodes={colorCodes}>
                <Typography
                    noWrap
                    overflow="hidden"
                    sx={{
                        fontSize: style.fontSize ? style.fontSize : '1.2rem',
                    }}
                >
                    {label}
                </Typography>

                {icon && (
                    <Link
                        onClick={(e) => {
                            e.stopPropagation()
                            onClose?.()
                        }}
                        aria-label="Remove filter"
                        {...(onClose && {
                            role: 'button',
                            tabIndex: 0,
                            onKeyDown: (e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    onClose()
                                }
                            },
                        })}
                    >
                        <StyledIcon display="flex" alignItems="center">
                            {icon}
                        </StyledIcon>
                    </Link>
                )}
            </StyledFilterChip>
        </Link>
    )
}

FilterChip.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
    onClose: PropTypes.func,
    closeIcon: PropTypes.bool,
    style: PropTypes.object,
}

FilterChip.defaultProps = {
    style: {},
}

export default FilterChip
